import React from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useTranslation } from "react-i18next"

interface DocumentPreviewDialogProps {
    open: boolean
    html: string
    onClose: () => void
}

const DocumentPreviewDialog: React.FC<DocumentPreviewDialogProps> = ({
    open,
    html,
    onClose,
}) => {
    const { t } = useTranslation()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{ sx: { minHeight: "80vh" } }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    py: 1.5,
                }}
            >
                {t("settings.documentPreview.title")}
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                <Box sx={{ width: "100%", height: "100%", minHeight: "70vh" }}>
                    <iframe
                        srcDoc={html}
                        title={String(
                            t("settings.documentPreview.iframeTitle")
                        )}
                        style={{
                            width: "100%",
                            height: "100%",
                            minHeight: "70vh",
                            border: "none",
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={{ textTransform: "none" }}>
                    {t("settings.documentPreview.close")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DocumentPreviewDialog
